import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import "./DetailProducts.css"; // Import your custom CSS file

const DetailProducts = () => {
  const { empid } = useParams();
  console.log(empid);

  const [empdata, empdatachange] = useState({});

  useEffect(() => {
    fetch(`https://dummyjson.com/products${empid}`)
      .then((resp) => {
        return resp.json();
      })
      .then((resp) => {
        empdatachange(resp.data.products);
        console.log(resp);
      })
      .catch((err) => {
        console.log(err.message);
      });
  }, []);

  return (
    <div>
      <div className="container_detail">
        <div className="card_detail row_detail">
          <div className="card-title_detail">
            <h2 className="detail_title_prod1"> Create Products</h2>
          </div>
          <div className="card-body_detail"></div>

          {empdata && (
            <div>
              <h2 className="detail_title_prod2">
                The Employee name is : <b>{empdata.name}</b> ({empdata.id})
              </h2>
              <h3 className="detail_title_prod3">Contact Details</h3>
              <h5 className="detail_title_prod3">Email is : {empdata.title}</h5>
              <h5 className="detail_title_prod3">
                Phone is : {empdata.description}
              </h5>
              <Link
                className="btn_detail btn-danger_detail"
                to="/listingproducts"
              >
                Back to Listing
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DetailProducts;
